import { defineModule } from '@core/index';
import NotFoundPage from '@pages/404/404-page-container';

export default defineModule({
  title: 'Страница не найдена',
  path: '*',
  component: NotFoundPage
});
